var Calendar = /** @class */ (function () {
    function Calendar(slot, options) {
        this.slot = slot;
        this.options = options || {};
        if (!this.options.yearRange) {
            this.options.yearRange = 'c-10:c+10';
        }
    }
    Object.defineProperty(Calendar.prototype, "cssPrefix", {
        get: function () {
            return 'kdtp-cal';
        },
        enumerable: true,
        configurable: true
    });
    Calendar.prototype.setDate = function (date) {
        this.currentDate = new Date(date);
    };
    Calendar.prototype.getDate = function () {
        return new Date(this.currentDate);
    };
    Calendar.prototype.dateChanged = function (apply) {
        if (this.options.onDateChanged) {
            this.options.onDateChanged(this.currentDate, apply);
        }
    };
    return Calendar;
}());
export { Calendar };
//# sourceMappingURL=calendar.js.map